
    <fieldmagic-dialog
      label="Send Welcome Email"
      icon="envelope-open-text"
      [instance]="self"
    >
      <ng-template fieldmagicDialogButtonsTmp>
        <fieldmagic-primary-button
          label="Send"
          icon="envelope"
          (click)="onSend()"
          [isInProgress]="processing$ | async"
        >
        </fieldmagic-primary-button>
      </ng-template>

      <ng-template fieldmagicDialogContentTmp>
        <fieldmagic-alert
          variant="info"
        >
          <fieldmagic-text
            content="{{ 'You are about to send a welcome email to %s. Please input the previously set password to include it in the email. Otherwise, leave the field blank if you wish not to include the password.' | translate | sprintf: [user.email_address] }}"
          >
          </fieldmagic-text>
        </fieldmagic-alert>
        <fieldmagic-text-input
          [standalone]="false"
          label="Previous Password"
          [(ngModel)]="password"
          [obsecure]="true"
        >
        </fieldmagic-text-input>
      </ng-template>
    </fieldmagic-dialog>
  